import { render, staticRenderFns } from "./RichTextEditDialog.vue?vue&type=template&id=3ef0d6ae&lang=pug"
import script from "./RichTextEditDialog.vue?vue&type=script&lang=js"
export * from "./RichTextEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports